import { getS3Image } from "./awsLib";
import icAvatar from "../assets/ic-avatar.png"

export function processPolls(polls, responses, isEmail=false) {
  return Promise.all(polls.map(async poll => {
    poll.date_closed=new Date(poll.date_closed) 
    poll.days_remaining =- Math.ceil(
      (Date.now() - poll.date_closed) / 1000 / 60 / 60 / 24
    );
    if (poll.author.UID === '073125a3-6b49-4e14-9f9c-d7bbdb6045f3' ||
        poll.author.UID === '96d40aa8-7d4c-4093-bfbd-07a155adddae') // if icitizen account (load static image)
      poll.author.avatarURL = icAvatar;
    else  
      poll.author.avatarURL = await getS3Image(poll.author.UID);
    poll.canVote = true;
    poll.isClosed = false;
    if (responses.includes(poll.poll_id) || isEmail) // user already voted
      poll.canVote = false;
    if (Date.now() > new Date(poll.date_closed)) {
      poll.canVote = false;
      poll.isClosed = true;
    }
    return poll
  }));
}